import { CalendarDays } from 'lucide-react';
import SvgColor from '../../../components/svg-color';

const icon = (name) =>
  name === 'luckyMeter' || name === 'MessageLogo' ? (
    <img src={`/assets/icons/navbar/${name}.png`} alt="lucky meter" style={{ width: 'auto', height: '100%' }} />
  ) : (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const navConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/message',
    icon: icon('MessageLogo'),
  },
  {
    title: 'Whatsapp',
    path: '/dashboard/blog',
    icon: icon('MessageLogo'),
  },
  {
    title: 'Event',
    path: '/dashboard/event',
    icon: <CalendarDays />,
  }
];

export default navConfig;